// Split-screen auth layout shared by the merchant login (/login) and the god-mode login:
// indigo gradient hero on the left, white form panel with the SuperCash logo on the right.
import Logo from "../Logo";

export default function AuthSplit({ headline, blurb, title, subtitle, onSubmit, children, footer, top }) {
  return (
    <div className="gl">
      <section className="gl-hero" aria-hidden="true">
        <svg className="gl-arcs" viewBox="0 0 600 800" preserveAspectRatio="none">
          {[0, 1, 2, 3, 4].map((i) => <path key={i} d={`M ${-80 + i * 60} 820 Q ${320 + i * 40} ${520 - i * 40} ${360 + i * 50} ${40 + i * 70}`} />)}
        </svg>
        <div className="gl-hero-in">
          <svg className="gl-mark" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9 4.9 19.1" /></svg>
          <h1>{headline}</h1>
          <p>{blurb}</p>
        </div>
        <div className="gl-foot">© {new Date().getFullYear()} SuperCash. All rights reserved.</div>
      </section>

      <section className="gl-side">
        <form onSubmit={onSubmit} className="gl-form">
          {top}
          <div className="gl-logo"><Logo height={108} /></div>
          <h2>{title}</h2>
          <p className="gl-sub">{subtitle}</p>
          {children}
          {footer}
        </form>
      </section>

      <style>{`
        .gl { min-height: 100vh; display: grid; grid-template-columns: minmax(0, 1.4fr) minmax(360px, 1fr); background: #fff; font-family: "Inter", system-ui, sans-serif; color: #111; }
        .gl-hero { position: relative; overflow: hidden; color: #fff; padding: 56px 64px; display: flex; flex-direction: column; background: radial-gradient(120% 90% at 0% 0%, #4c4ff0 0%, #2f33d6 45%, #1c1aa0 100%); }
        .gl-arcs { position: absolute; inset: 0; width: 100%; height: 100%; opacity: .22; }
        .gl-arcs path { fill: none; stroke: #c9ccff; stroke-width: 1.2; }
        .gl-hero-in { position: relative; margin: auto 0; max-width: 520px; }
        .gl-mark { color: #fff; margin-bottom: 36px; }
        .gl-hero h1 { margin: 0 0 22px; font-size: clamp(40px, 5vw, 64px); line-height: 1.08; font-weight: 800; letter-spacing: -0.03em; }
        .gl-wave { display: inline-block; transform-origin: 70% 70%; animation: glWave 2.4s ease-in-out 1; }
        @keyframes glWave { 0%,60%,100% { transform: rotate(0) } 10%,30% { transform: rotate(14deg) } 20%,40% { transform: rotate(-8deg) } }
        .gl-hero p { margin: 0; font-size: 18px; line-height: 1.5; color: rgba(255,255,255,.88); }
        .gl-foot { position: relative; font-size: 14px; color: rgba(255,255,255,.6); }
        .gl-side { display: flex; align-items: center; justify-content: center; padding: 48px 32px; box-shadow: -40px 0 80px -60px rgba(47,51,214,.45) inset; }
        .gl-form { width: 100%; max-width: 360px; display: flex; flex-direction: column; }
        .gl-logo { height: 76px; display: flex; align-items: center; overflow: hidden; margin: 0 0 56px -13px; }
        .gl-form h2 { margin: 0 0 8px; font-size: 30px; font-weight: 800; letter-spacing: -0.02em; }
        .gl-sub { margin: 0 0 32px; font-size: 14px; color: #6b6b76; }
        .gl-input { border: 0; border-bottom: 1.5px solid #d9d9e0; padding: 14px 4px; font: inherit; font-size: 15px; color: #111; background: transparent; outline: none; margin-bottom: 14px; transition: border-color .15s; border-radius: 0; }
        .gl-input:focus { border-color: #2f33d6; }
        .gl-input::placeholder { color: #9a9aa6; }
        .gl-err { font-size: 13px; color: #c62828; background: #fdecec; border-radius: 8px; padding: 9px 12px; margin: 4px 0 6px; }
        .gl-btn { margin-top: 22px; height: 50px; border: 0; border-radius: 10px; background: #15151b; color: #fff; font: inherit; font-size: 15px; font-weight: 600; cursor: pointer; transition: background .15s, transform .08s; }
        .gl-btn:hover { background: #2b2b35; }
        .gl-btn:active { transform: translateY(1px); }
        .gl-btn:disabled { opacity: .6; cursor: default; }
        .gl-help { margin: 22px 0 0; text-align: center; font-size: 13px; color: #8a8a95; }
        .gl-help a { color: #111; font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }
        .gl-back { align-self: flex-start; margin-bottom: 18px; font-size: 13px; font-weight: 500; color: #6b6b76; text-decoration: none; }
        .gl-back:hover { color: #2f33d6; }
        @media (max-width: 860px) {
          .gl { grid-template-columns: 1fr; }
          .gl-hero { padding: 36px 24px; min-height: 260px; }
          .gl-mark { width: 44px; height: 44px; margin-bottom: 18px; }
          .gl-hero p { font-size: 15px; }
          .gl-foot { display: none; }
          .gl-logo { height: 64px; margin-bottom: 24px; }
          .gl-logo img { height: 92px !important; }
        }
      `}</style>
    </div>
  );
}
